/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Actions</h2>
    <p className={styles.description}>
      <b>Действия</b> (<code className={styles.code}>actions</code>) - это объекты, которые помогают доставить данные из
      компонентов в хранилище.{' '}
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>Хранят минимально необходимый набор информации. </li>
      <li className={styles.list__item}>
        Должны иметь свойство <code className={styles.code}>type</code>, которое указывает тип выполняемого действия.{' '}
      </li>
      <li className={styles.list__item}>
        Помимо поля <code className={styles.code}>type</code>, структура действия может быть произвольной.{' '}
      </li>
    </ul>
    <CopyBlock
      text={`const action = {
  type: 'ADD_NOTE',
  payload: {
    text: 'Redux is awesome!',
  },
};`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Действия создаются функциями (<code className={styles.code}>action creators</code>), которые могут быть
      асинхронными и иметь побочные эффекты. В базовом варианте они просто возвращают объект-дейтсвие.{' '}
    </p>
    <CopyBlock
      text={`const addNote = text => ({
  type: 'ADD_NOTE',
  payload: {
    id: Date.now(),
    text,
  },
});

const deleteNote = id => ({
  type: 'DELETE_NOTE',
  payload: {
    id,
  },
});`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
